/**
 * ראשי תיבות לתצוגה באווטאר (שם מלא → עד שני תווים).
 */
export function getDisplayInitials(displayName?: string | null): string {
  const s = displayName?.trim();
  if (!s) return "?";
  const words = s.split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) {
    const chars = Array.from(words[0]).slice(0, 2).join("");
    return chars.toUpperCase();
  }
  const first = Array.from(words[0])[0] ?? "";
  const last = Array.from(words[words.length - 1])[0] ?? "";
  return `${first}${last}`.toUpperCase();
}
